module.exports = __webpack_public_path__ + "static/img/KZ@3x.735a8577.jpg";